import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import '../modules/error-modal'

const FormErrorModal = {
    
    bindEvents() {

        jQuery(document).on('form-errors', '.use-error-modal', (event, validator) => {
            EventBus.publish('error', {
                validator: validator
            })
        })
        
    }
    
}

FormErrorModal.bindEvents()

export default FormErrorModal